import { getRequest } from '../api-handler';
import { CustomerDetailDto } from './customer';

export const CustomerApi = {
  getById: (id: number) => getRequest<CustomerDetailDto>(`/customers/${id}`)
};
